var _rect, _rect2, _rect3, _line, _rect4, _line2, _rect5, _line3, _rect6, _line4, _rect7, _line5, _rect8, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDesktopMostPopularPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 300,
  height: 785,
  viewBox: "0 0 300 785",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 1.37012,
  width: 299,
  height: 783,
  rx: 7.5,
  stroke: "black",
  strokeOpacity: 0.2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 20.8701,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 63.8701,
  width: 260,
  height: 70,
  fill: "#E5E5E5"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 154.37,
  x2: 20,
  y2: 154.37,
  stroke: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 173.87,
  width: 260,
  height: 70,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 264.37,
  x2: 20,
  y2: 264.37,
  stroke: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 283.87,
  width: 260,
  height: 70,
  fill: "#E5E5E5"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 374.37,
  x2: 20,
  y2: 374.37,
  stroke: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 393.87,
  width: 260,
  height: 70,
  fill: "#E5E5E5"
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 484.37,
  x2: 20,
  y2: 484.37,
  stroke: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 503.87,
  width: 260,
  height: 70,
  fill: "#E5E5E5"
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  x1: 280,
  y1: 594.37,
  x2: 20,
  y2: 594.37,
  stroke: "#110000"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 613.87,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 656.87,
  width: 260,
  height: 28,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 696.87,
  width: 260,
  height: 28,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 736.87,
  width: 260,
  height: 28,
  fill: "#E5E5E5"
})));
export default SvgDesktopMostPopularPlaceholder;